import React, { useState } from 'react';
import { Globe2, Users, TrendingUp, Flag, Leaf, MapPin, ChevronDown, ChevronUp } from 'lucide-react';
interface CardProps {
  title: string;
  eje: string;
  topics: string[];
  icon: React.ReactNode;
  iconBg: string;
  isOpen: boolean;
  onToggle: () => void;
}
function AccordionCard({
  title,
  eje,
  topics,
  icon,
  iconBg,
  isOpen,
  onToggle
}: CardProps) {
  return <div className={`bg-gray-50 border rounded-xl overflow-hidden transition-all duration-300 shadow-sm group cursor-pointer ${isOpen ? 'border-[#f59e0b] ring-1 ring-[#f59e0b]/30' : 'border-gray-200 hover:border-[#f59e0b]'}`} onClick={onToggle} data-id="element-175">
      <div className="p-3 sm:p-5" data-id="element-176">
        <div className="flex items-start gap-3 sm:gap-4" data-id="element-177">
          <div className={`${iconBg} w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors`} data-id="element-178">
            {icon}
          </div>
          <div className="flex-1" data-id="element-179">
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1 leading-tight" data-id="element-180">
              {title}
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 font-medium mb-1" data-id="element-181">
              <span className="text-[#f59e0b] font-bold" data-id="element-182">Eje:</span> {eje}
            </p>
          </div>
          <div className="text-gray-400 mt-1" data-id="element-183">
            {isOpen ? <ChevronUp size={20} data-id="element-184" /> : <ChevronDown size={20} data-id="element-185" />}
          </div>
        </div>

        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 mt-3 sm:mt-4' : 'max-h-0 opacity-0'}`} data-id="element-186">
          <div className="h-px bg-gray-200 mb-3 sm:mb-4" data-id="element-187"></div>
          <ul className="space-y-1.5 sm:space-y-2" data-id="element-188">
            {topics.map((topic, idx) => <li key={idx} className="text-xs sm:text-sm text-gray-600 flex items-start" data-id="element-189">
                <span className="text-[#f59e0b] mr-2" data-id="element-190">•</span>
                {topic}
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
}
export function QueIncluye() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const cards = [{
    title: 'CUADERNILLO 1 — Fundamentos de la Geografía y Herramientas de Análisis Espacial',
    eje: 'Construcción del espacio geográfico',
    topics: ['La Geografía como ciencia social', 'Espacio geográfico y relaciones sociedad–naturaleza', 'Paisajes: clasificación y análisis', 'Representaciones de la Tierra', 'Proyecciones cartográficas', 'Mapas, planos y cartas', 'Coordenadas geográficas (latitud y longitud)', 'Lectura e interpretación de mapas', 'Actividades prácticas de aplicación'],
    icon: <Globe2 className="text-blue-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-191" />,
    iconBg: 'bg-blue-100'
  }, {
    title: 'CUADERNILLO 2 — Población, Territorio y Dinámicas Demográficas',
    eje: 'Organización social del espacio',
    topics: ['Crecimiento y distribución de la población', 'Indicadores demográficos', 'Pirámides de población', 'Migraciones y movilidad territorial', 'Transformaciones demográficas actuales', 'Mapas temáticos poblacionales', 'Análisis e interpretación de datos', 'Actividades aplicadas'],
    icon: <Users className="text-green-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-192" />,
    iconBg: 'bg-green-100'
  }, {
    title: 'CUADERNILLO 3 — Economía, Producción y Organización Territorial',
    eje: 'Actividades económicas y desigualdades espaciales',
    topics: ['Sistemas y modelos económicos', 'Sectores de la economía', 'Recursos naturales y producción', 'Globalización y economía mundial', 'Circuitos productivos', 'Distribución desigual del desarrollo', 'Estudios de caso', 'Actividades de análisis territorial'],
    icon: <TrendingUp className="text-purple-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-193" />,
    iconBg: 'bg-purple-100'
  }, {
    title: 'CUADERNILLO 4 — Organización Política del Espacio Mundial',
    eje: 'Estados, territorios y geopolítica',
    topics: ['El Estado y sus componentes', 'Formas de gobierno', 'Fronteras y soberanía', 'Organismos internacionales', 'Bloques regionales', 'Conflictos territoriales contemporáneos', 'Mapas políticos', 'Actividades de análisis crítico'],
    icon: <Flag className="text-pink-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-194" />,
    iconBg: 'bg-pink-100'
  }, {
    title: 'CUADERNILLO 5 — Ambiente, Recursos y Desarrollo Sostenible',
    eje: 'Sistemas naturales y problemáticas ambientales',
    topics: ['Relieve terrestre', 'Clima: elementos y factores', 'Zonas climáticas y biomas', 'Hidrografía y cuencas', 'Problemas ambientales actuales', 'Cambio climático', 'Riesgos naturales', 'Desarrollo sostenible', 'Actividades integradoras'],
    icon: <Leaf className="text-cyan-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-195" />,
    iconBg: 'bg-cyan-100'
  }, {
    title: 'CUADERNILLO 6 — Argentina y su Organización Territorial',
    eje: 'Espacio geográfico nacional y dinámicas actuales',
    topics: ['Organización territorial argentina', 'Regiones y ambientes', 'Población argentina', 'Actividades económicas nacionales', 'Circuitos productivos', 'Migraciones internas', 'Problemas ambientales en Argentina', 'Actividades de análisis territorial'],
    icon: <MapPin className="text-orange-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-196" />,
    iconBg: 'bg-orange-100'
  }];
  return <section id="que-incluye" className="py-5 sm:py-14 bg-white relative overflow-hidden" data-id="element-197">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5" data-id="element-198">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-blue-600 rounded-full blur-3xl" data-id="element-199"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-purple-600 rounded-full blur-3xl" data-id="element-200"></div>
      </div>

      <div className="max-w-6xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-201">
        <div className="text-center mb-4 sm:mb-10" data-id="element-202">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-203">
            ¿Qué incluye el{' '}
            <span className="text-[#f59e0b]" data-id="element-204">Kit Completo Geografía Lista</span>
            ?
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto" data-id="element-205">
            Este mega combo reúne material de geografía educativa en un solo
            lugar, con recursos prácticos, actuales y pensados para aplicar
            directamente en el aula.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6 mb-4 sm:mb-10" data-id="element-206">
          {cards.map((card, index) => <AccordionCard key={index} {...card} isOpen={openIndex === index} onToggle={() => handleToggle(index)} data-id="element-207" />)}
        </div>
      </div>
    </section>;
}